import reduceReducers from "reduce-reducers";

import {
  BILLING_DOCUMENT,
  CONTACT_BILLING_DOCUMENT,
} from "constants/actionTypes";

import { apiModelOfflineFetchReducer, bulkUpdateCases } from "lib/reducers";
import { deserializeBillingDocument } from "lib/serializers/billingDocuments";

const fetch = apiModelOfflineFetchReducer(CONTACT_BILLING_DOCUMENT, {
  deserializer: deserializeBillingDocument,
  clearOnRequest: false,
});

const mirrorBillingDocumentBulkUpdates = (state, action) => {
  switch (action.type) {
    case BILLING_DOCUMENT.UPDATE_BULK.REQUEST:
    case BILLING_DOCUMENT.UPDATE_BULK.SUCCESS:
    case BILLING_DOCUMENT.UPDATE_BULK.FROM_SOCKET: {
      return bulkUpdateCases(
        state,
        action,
        "byId",
        deserializeBillingDocument,
        {},
      );
    }

    default:
      return state;
  }
};

const contactBillingDocumentReducer = reduceReducers(
  fetch,
  mirrorBillingDocumentBulkUpdates,
);

export default contactBillingDocumentReducer;
